/** Подія картки довідника: відкрити підтвердження видалення (слухає DictionaryDeleteAction) */
export const DICTIONARY_DELETE_EVENT = 'dictionaryDelete:open'
